'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const ContainerModel = require('data/domain/entity/container');
const ContainerAPI = require('data/infra/api/container/index');

class Repository {
    constructor(project) {
        this._project = project;
        this._rootContainer = null;
        this._allContainers = new Backbone.Collection();
        this._cache = {};
        this._fetched = {};
    }

    fetchRoot() {
        const projectID = this._project.id;

        return ContainerAPI.getRootContainer(projectID)
            .then(containerJSON => {
                const containerModel = new ContainerModel(containerJSON);
                this.add([containerModel]);
                this._rootContainer = containerModel;
                return containerModel;
            });
    }

    fetchRootOnce() {
        if (this._rootContainer) {
            return new Promise(resolve => {
                resolve(this._rootContainer);
            });
        }

        let promise = this._fetched['root'];
        if (!promise) {
            promise = this.fetchRoot();
            this._fetched['root'] = promise;
        }
        return promise;
    }

    fetchChildContainers(parentContainer) {
        const projectID = this._project.id;
        const parentContainerID = parentContainer.id;

        return ContainerAPI.fetchChildContainers(projectID, parentContainerID)
            .then(response => {
                const containersJSON = response.containers;
                if (!this._cache[parentContainerID]) {
                    this._cache[parentContainerID] = new Backbone.Collection([]);
                }

                const models = _.map(containersJSON, j => {
                    const model = new ContainerModel(j);
                    this.add(model);
                    return model;
                });

                this._cache[parentContainerID].add(models);
                return this._cache[parentContainerID];
            });
    }

    fetchChildContainersOnce(parentContainer) {
        if (this._cache[parentContainer.id]) {
            return new Promise(resolve => {
                resolve(this._cache[parentContainer.id]);
            });
        }

        const cacheKey = `${parentContainer.id}/children`;
        let promise = this._fetched[cacheKey];
        if (!promise) {
            promise = this.fetchChildContainers(parentContainer);
            this._fetched[cacheKey] = promise;
        }

        return promise;
    }

    fetchContainer(containerID) {
        const projectID = this._project.id;

        return ContainerAPI.fetchContainer(projectID, containerID)
            .then(response => {
                const model = new ContainerModel(response);
                this.add(model);

                if (model.getParent()) {
                    const parentContainerID = model.getParent().id;
                    if (!this._cache[parentContainerID]) {
                        this._cache[parentContainerID] = new Backbone.Collection([]);
                    }
                    this._cache[parentContainerID].add(model);
                }

                return model;
            });
    }

    fetchContainerOnce(containerID) {
        if (this._allContainers.get(containerID)) {
            return new Promise(resolve => {
                resolve(this._allContainers.get(containerID));
            });
        }

        const cacheKey = containerID;
        let promise = this._fetched[cacheKey];
        if (!promise) {
            promise = this.fetchContainer(containerID);
            this._fetched[cacheKey] = promise;
        }
        return promise;
    }

    add(container) {
        this._allContainers.add(container, {merge: true});
    }
}

const repositories = {};

const find = (project) => {
    let r = repositories[project.id];
    if (!r) {
        r = new Repository(project);
        repositories[project.id] = r;
    }
    return r;
};

module.exports = {
    find: find
};



// WEBPACK FOOTER //
// ./data/domain/repository/container/index.js